module.exports = __webpack_public_path__ + "static/media/lapis-lazuli.20b67133.jpg";